// extracted by mini-css-extract-plugin
module.exports = {"notification-box":"styles_notification-box__-XoZw"};